// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-to-plan-creditcard[data-v-8631a020]{color:#404040;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
